import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function Tabs({ tabs, initialTab, onTabClick }) {
  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    setActiveTab(initialTab);
  }, [initialTab]);

  return (
    <div>
      {/* Tab Navigation */}
      <nav
        className="relative z-0 flex border rounded-xl overflow-hidden"
        aria-label="Tabs"
      >
        {tabs.map((tab) => (
          // eslint-disable-next-line jsx-a11y/role-supports-aria-props
          <button
            key={tab.id}
            type="button"
            onClick={() => {
              setActiveTab(tab.id);
              onTabClick(tab.id);
            }}
            className={`${
              activeTab === tab.id
                ? "border-b-8 border-b-blue-500 text-orange-600 font-bold text-lg border"
                : "border-b-2 border-transparent text-gray-500 hover:text-gray-700"
            } relative min-w-0 flex-1 bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:outline-none`}
            aria-selected={activeTab === tab.id}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      {/* Tab Content */}
      <div className="mt-3">
        {tabs.map((tab) => (
          <div key={tab.id} hidden={activeTab !== tab.id}>
            {tab.content}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Tabs;
